module.exports = __webpack_public_path__ + "img/mi-explore.bbdf91b4.svg";